export const DEFAULT_GUTTER: [number, number] = [8, 10];
